import ThemeCard from './ThemeCard';

export default ThemeCard;
